<template>
  <div class="bg-lightGrey">
    <div class="bg-whiteOverride rounded border-border border-1 border-solid">

      <div class="p-lg">
        <h1>Cards</h1>

        <div class="pb-lg">
          <h2>&lt;CardContainer&gt;</h2>
          <CardContainer class="p-sm">
            <p>Dummy Content</p>
          </CardContainer>
        </div>

        <hr />

        <div class="pb-lg">
          <h2>&lt;HeaderCard&gt;</h2>
          <HeaderCard>
            <template v-slot:header>
              Header here
            </template>
            <template v-slot:content>
              <div class="p-sm">
                <p>Dummy Content</p>
              </div>
            </template>
          </HeaderCard>
        </div>

        <hr />

        <div class="pb-lg">
          <h2>&lt;ExpandableCard&gt; (#1 - default controls)</h2>
          <p class="italic text-primaryGrey">See console for amplitude events (event category: card1)</p>
          <ExpandableCard
            minimiseLabel="Minimise"
            maximiseLabel="Maximise"
            logEventCategory="card1"
            @minimised="() => cardMinimised(1)"
            @maximised="() => cardMaximised(1)"
            @toggled="(newVal) => cardToggled(1, newVal)"
          >
            <template v-slot:header>
              Header here
            </template>
            <template v-slot:content>
              <div class="p-sm">
                <p>Dummy Content</p>
              </div>
            </template>
            <template v-slot:expandedContent>
              <div class="p-sm">
                <p>Expanded Content</p>
              </div>
            </template>
          </ExpandableCard>
        </div>

        <hr />

        <div class="pb-lg">
          <h2>&lt;ExpandableCard&gt; (#2 - toggle controls)</h2>
          <p class="italic text-primaryGrey">See console for amplitude events (event category: card2)</p>
          <ExpandableCard
            toggleable
            minimiseLabel="Minimise"
            maximiseLabel="Maximise"
            logEventCategory="card2"
            @minimised="() => cardMinimised(2)"
            @maximised="() => cardMaximised(2)"
            @toggled="(newVal) => cardToggled(2, newVal)"
          >
            <template v-slot:header>
              Header here
            </template>
            <template v-slot:content>
              <div class="p-sm">
                <p>Dummy Content</p>
              </div>
            </template>
            <template v-slot:expandedContent>
              <div class="p-sm">
                <p>Expanded Content</p>
              </div>
            </template>
          </ExpandableCard>
        </div>

        <hr />

        <div class="pb-lg">
          <h2>&lt;ExpandableCard&gt; (#3 - custom controls)</h2>
          <p class="italic text-primaryGrey">See console for amplitude events (event category: card3, specified/overridden event types)</p>
          <ExpandableCard
            minimiseLabel="Minimise"
            maximiseLabel="Maximise"
            logEventCategory="card3"
            logMinimiseEventName="minimised_card_3"
            logMaximiseEventName="maximised_card_3"
            logToggleEventName="toggled_card_3"
            @minimised="() => cardMinimised(3)"
            @maximised="() => cardMaximised(3)"
            @toggled="(newVal) => cardToggled(3, newVal)"
          >
            <template v-slot:header>
              Header here
            </template>
            <template v-slot:controls>
              No controls here
            </template>
            <template v-slot:content="{ minimise, maximise, toggle, isExpanded }">
              <div class="p-sm">
                <p>Dummy Content</p>
                <p>Current status: {{ isExpanded ? 'Expanded' : 'Collapsed' }} </p>
                <p>
                  <span
                    @click="minimise"
                    class="cursor-pointer underline"
                  >
                    Minimise
                  </span>,
                  <span
                    @click="maximise"
                    class="cursor-pointer underline"
                  >
                    Maximise
                  </span>
                  or
                  <span
                    @click="toggle"
                    class="cursor-pointer underline"
                  >
                    Toggle
                  </span>.
                </p>
              </div>
            </template>
            <template v-slot:expandedContent>
              <div class="p-sm">
                <p>Expanded Content</p>
              </div>
            </template>
          </ExpandableCard>
        </div>

      </div>

    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-param-reassign */
import { CardContainer } from '@/components/library/containers';
import { HeaderCard, ExpandableCard } from '@/components/library/cards';

function cardMinimised(n) {
  console.log(`Card ${n}: minimised`);
}

function cardMaximised(n) {
  console.log(`Card ${n}: maximised`);
}

function cardToggled(n, newVal) {
  console.log(`Card ${n}: toggled; new value: ${newVal}`);
}
</script>
